import { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import {
  registerApproveTriageClip,
  registerGetChallenge,
  registerGetCollection,
  registerListCollections,
  registerRejectTriageClip,
  registerSearchChallenges,
  registerSearchCollections,
} from './tools';

export function createMcpServer(): McpServer {
  const server = new McpServer({ name: 'coolmate-web', version: '1.0.0' });
  registerSearchChallenges(server);
  registerSearchCollections(server);
  registerListCollections(server);
  registerGetCollection(server);
  registerGetChallenge(server);
  registerApproveTriageClip(server);
  registerRejectTriageClip(server);
  return server;
}
